AdminSchoolsController.$inject = ["$scope", "$state"];
function AdminSchoolsController($scope, $state) {}
export default AdminSchoolsController;

